/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthSecretCommand } from '../models/AuthSecretCommand';
import type { AuthTokenCommand } from '../models/AuthTokenCommand';
import type { ResponseData_AuthSecretResponse } from '../models/ResponseData_AuthSecretResponse';
import type { ResponseData_AuthTokenResponse } from '../models/ResponseData_AuthTokenResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthorizeService {
    /**
     * Получить секретный ключ для авторизации по ЭЦП.
     * @returns ResponseData_AuthSecretResponse OK
     * @throws ApiError
     */
    public static postApiV1AuthorizeSecret({
        requestBody,
    }: {
        requestBody?: AuthSecretCommand,
    }): CancelablePromise<ResponseData_AuthSecretResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/authorize/secret',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить JWT токен
     * @returns ResponseData_AuthTokenResponse OK
     * @throws ApiError
     */
    public static postApiV1AuthorizeToken({
        requestBody,
    }: {
        requestBody?: AuthTokenCommand,
    }): CancelablePromise<ResponseData_AuthTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/authorize/token',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
